// @flow

import type { ManagerSmsNotificationsState } from "./types";

export const initialState: ManagerSmsNotificationsState = {
  requestsInProgress: 0,
  smsRules: {
    content: [],
    pagination: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    totalElements: 0,
  },
  pagerRules: {
    content: [],
    pagination: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    totalElements: 0,
  },
  current: null,
  assignments: [],
  settings: null,
  modals: {
    showAddModal: false,
    showEditModal: false,
    showDeleteModal: false,
  },
};

export default initialState;
